import user from "../../api/user";
import router from "../../router/index";
import {navLinks} from "@/mixins/navLinks";

const state = {
    institutionModalVisible: false,
    accountSettingModalVisible: false,
    userInfo: {},
    permissionCode: new Set(),
    messageList: {},
    messageFilter: {},
};

const getters = {};
const mutations = {
    setData(state, {key, value}) {
        state[key] = value;
    },
    goToFirstMenu(state) {
        for (let navLink of navLinks) {
            if (state.permissionCode.has(navLink.permissionCode)) {
                if (navLink.children) {
                    for (let menu of navLink.children) {
                        router.push({name: menu.routerName});
                        return;
                    }
                } else {
                    router.push({name: navLink.routerName});
                    return;
                }
            }
        }
    }
};
const actions = {
    // eslint-disable-next-line no-empty-pattern
    async addMessageReceive({}, payload) {
        return await user.addMessageReceive(payload)
    },
    // eslint-disable-next-line no-empty-pattern
    async getSystemMessage({commit}, payload) {
        try {
            const params = {
                size: state.messageList.size,
                ...payload,
            };
            let res = await user.getSystemMessage.getList(params);
            commit("setData", {key: "messageList", value: res.data});
            return res;
        } finally {

        }
    },
    // eslint-disable-next-line no-empty-pattern
    async demoLogin({}, payload) {
        await user.demoLogin(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async login({}, payload) {
        await user.login(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async loginOut({}, payload) {
        await user.loginOut(payload);
        localStorage.removeItem("tenantId");
    },
    // eslint-disable-next-line no-empty-pattern
    async register({}, payload) {
        await user.register(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async sendSms({}, payload) {
        return await user.sendSms(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async registerTenant({}, payload) {
        return await user.registerTenant(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getUserInfo({commit}) {
        const res = await user.getUserInfo();
        commit("setData", {key: "userInfo", value: res.data});
    },
    // eslint-disable-next-line no-empty-pattern
    async getUserPermission({commit}) {
        const res = await user.getUserPermission();
        commit("setData", {key: "permissionCode", value: new Set(res.data)});
        return res;
    },
    // eslint-disable-next-line no-empty-pattern
    async updateUserInfo({}, payload) {
        await user.updateUserInfo(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getAuthorize({}, payload) {
        return await user.getAuthorize(payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
